//Constants
import * as ACTIONS from './actionTypes';
import { WidgetPageType } from './types';

//Types
import { ActionSetShowPreview, ActionGetWidgetsConfigSuccess, ActionGetWidgetsPublishSuccess, ActionGetWidgetsHtmlCallsSuccess, ActionSaveWidgetsConfigSuccess, ActionSaveWidgetsPublishSuccess, 
    ActionGetOverallRatingSuccess, ActionProvidersRatingSuccess, ActionGetReviewsSuccess, ActionGetReviewsConfigSuccess, ActionGetReviewsFilteredSuccess, ActionSetSelectedTabConfig} from './actions';
import { OverallRatingResponse, Widgets, WidgetsCalls, ProvidersRatingResponse, Review, ReviewsConfig, ReviewsFiltered } from './types';

export interface ReviewsState {
    showPreview: boolean;
    widgets: Widgets | undefined;
    widgetsPublish: Widgets | undefined;
    reviews: Review[] | undefined;
    reviewsConfig: ReviewsConfig | undefined;
    widgetsCalls: WidgetsCalls | undefined;
    overallRating: OverallRatingResponse | undefined;
    providersRating: ProvidersRatingResponse | undefined;
    reviewsFiltered: ReviewsFiltered | undefined;
    selectedTab: WidgetPageType;
}

const defaultState: ReviewsState = {    
    showPreview: false,
    widgets: undefined,
    widgetsPublish: undefined,
    reviews: undefined,
    reviewsConfig: undefined,
    widgetsCalls: undefined,
    overallRating: undefined,
    providersRating: undefined,
    reviewsFiltered: undefined,
    selectedTab: "individual",
};

type GetReviewsAPIAction =  ActionSetShowPreview | ActionGetWidgetsConfigSuccess | ActionGetWidgetsPublishSuccess | ActionGetWidgetsHtmlCallsSuccess | ActionGetOverallRatingSuccess | ActionProvidersRatingSuccess | ActionGetReviewsSuccess | ActionGetReviewsConfigSuccess |ActionGetReviewsFilteredSuccess | ActionSetSelectedTabConfig; 

function ReviewsReducer(state: ReviewsState = defaultState, action: GetReviewsAPIAction ): ReviewsState {
    switch (action.type) {
        case ACTIONS.SET_SHOW_PREVIEW:
            {
                const showPreview = (action as ActionSetShowPreview).showPreview
                return{
                    ...state,                    
                    showPreview
                }
            }
        case ACTIONS.GET_WIDGETS_CONFIG_SUCCESS:
            {
                const widgets = (action as ActionGetWidgetsConfigSuccess).widgets
                return{
                    ...state,                    
                    widgets
                }
            }
        case ACTIONS.GET_WIDGETS_PUBLISH_SUCCESS:
            {
                const widgetsPublish = (action as ActionGetWidgetsPublishSuccess).widgetsPublish
                return{
                    ...state,                    
                    widgetsPublish
                }
            }
        case ACTIONS.GET_REVIEWS_SUCCESS:
                {
                    const reviews = (action as ActionGetReviewsSuccess).reviews
                    return{
                        ...state,                    
                        reviews
                    }
                }
        case ACTIONS.GET_REVIEWS_CONFIG_SUCCESS:
                    {
                        const reviewsConfig = (action as ActionGetReviewsConfigSuccess).reviewsConfig
                        return{
                            ...state,                    
                            reviewsConfig
                        }
                    }
        case ACTIONS.GET_WIDGETS_HTML_CALLS_SUCCESS:
            {
                const widgetsCalls = (action as ActionGetWidgetsHtmlCallsSuccess).widgetsCalls
                return{
                    ...state,                    
                    widgetsCalls
                }
            }
        case ACTIONS.GET_OVERALL_RATING_SUCCESS:
                {
                    const overallRating = (action as ActionGetOverallRatingSuccess).overallRating;
                    return{
                        ...state,                    
                        overallRating
                    }
                }
        case ACTIONS.SAVE_WIDGETS_CONFIG_SUCCESS:
                {
                    const widgets = (action as ActionSaveWidgetsConfigSuccess).widgets
                    return{
                        ...state,                    
                        widgets
                    }
                }
        case ACTIONS.SAVE_WIDGETS_PUBLISH_SUCCESS:
                {
                    const widgetsPublish = (action as ActionSaveWidgetsPublishSuccess).widgetsPublish
                    return{
                        ...state,                    
                        widgetsPublish
                    }
                }
        case ACTIONS.GET_PROVIDERS_RATING_SUCCESS:
            {
                const providersRating = (action as ActionProvidersRatingSuccess).providersRating
                return{
                    ...state,                    
                    providersRating
                }
            }
        case ACTIONS.GET_REVIEWS_FILTERED_SUCCESS:
            {
                const reviewsFiltered = (action as ActionGetReviewsFilteredSuccess).reviewsFiltered
                return{
                    ...state,                    
                    reviewsFiltered
                }
            }
        case ACTIONS.SET_SELECTED_TAB_CONFIG:
            {
                const selectedTab = (action as ActionSetSelectedTabConfig).selectedTab
                return{
                    ...state,                    
                    selectedTab
                }
            }
    }
    return {
        ...state
    }
}

export default ReviewsReducer;